export const form_po_visibility = {
  dispatch_summary: [
    {
      label: "receive_consignor",
      // label: 'customer_label_pov',
      type: "info",
      id: "Consignor",
      class: "_align _name",
      colm: 2,
      md: 3,
    },
    {
      label: "receive_consignee",
      type: "info",
      // typeValue: 'number',
      id: "Consignee",
      class: "_align _name",
      colm: 2,
      md: 3,
    },
    {
      label: "dispatch_rcn_reference_no",
      type: "info",
      id: "ReferenceNo",
      class: "_align _name",
      colm: 2,
      md: 3,
    },
    {
      label: "dispatch_warehouse",
      type: "info",
      id: "Warehouse",
      class: "_align _name",
      colm: 2,
      md: 3,
    },
    {
      label: "receive_numberpackages",
      type: "info",
      id: "Numberpackages",
      class: "_align _name",
      colm: 2,
      md: 3,
    },
    {
      label: "dispatch_observation",
      type: "info",
      id: "Description",
      class: "_align _name",
      colm: 2,
      md: 3,
    },
    {
      label: "receive_asn",
      type: "info",
      id: "ASN",
      class: "_align _name",
      colm: 2,
      md: 3,
    },
    {
      label: "receive_arrived",
      type: "info",
      id: "Arrived",
      class: "_align _name",
      colm: 2,
      md: 3,
    },
    {
      label: "receive_unloaded",
      type: "info",
      id: "Unloaded",
      class: "_align _name",
      colm: 2,
      md: 3,
    },
    {
      label: "receive_finalized",
      type: "info",
      id: "Finalized",
      class: "_align _name",
      colm: 2,
      md: 3,
    },
    {
      label: "receive_TotalWeight",
      type: "info",
      id: "TotalWeight",
      class: "_align _name",
      colm: 2,
      md: 3,
    },
    {
      label: "receive_totalvolume",
      type: "info",
      id: "Totalvolume",
      class: "_align _name",
      colm: 2,
      md: 3,
    },
  ],
};
